import fetch from '../fetch';

const path = process.env.VUE_APP_BASE_SERVER_URL;

export const fetchAreaList = req =>
  fetch({
    url: path + '/dcxy/baseArea/queryAlls',
    method: 'get',
    ...req,
  });
export const fetchAccessAreaList = req =>
  fetch({
    url: path + '/dcxy/baseArea/queryAll',
    method: 'get',
    ...req,
  });
export const fetchDashboardAreaList = req =>
  fetch({
    url: path + '/dcxy/baseArea/findAccessArea',
    method: 'POST',
    ...req,
  });
//获取下拉列表
export const fetchSelectList = req =>
  fetch({
    url: path + '/baseData/get/baseData',
    method: 'get',
    ...req,
  });

//获取服务类型
export const fetchServiceList = req =>
  fetch({
    url: path + '/dcxy/api/base/service/all/about/service',
    method: 'get',
    ...req,
  });
// 根据区域获取服务
export const fetchAreaService = req =>
  fetch({
    url: path + '/dcxy/api/base/service/together/relation',
    method: 'get',
    ...req,
  });
// 获取运营商
export const fetchOperatorList = req =>
  fetch({
    url: path + '/dcxy/baseOperator/queryAll',
    method: 'get',
    ...req,
  });
// 获取权限运营商
export const fetchAccessOperatorList = req =>
  fetch({
    url: path + '/dcxy/baseOperator/queryAccessOper',
    method: 'get',
    ...req,
  });
// 获取豆类型
export const fetchBeansList = req =>
  fetch({
    url: path + '/baseData/beans',
    method: 'get',
    ...req,
  });
// 获取所有菜单
export const fetchMenuTree = req =>
  fetch({
    url: '/menu/menuButton/list',
    method: 'get',
    ...req,
  });
// 获取所有系统用户
export const fetchAdminList = req =>
  fetch({
    url: '/admin/admin',
    method: 'get',
    notLoading: true,
    ...req,
  });
